import { homeJumbo, largeJumbo } from './jumbo';
import footerTop from "../bkw/footerTop";
import newsletterBlock from "../bkw/newsLetterForm";
import { customImageCrops } from './imageCrops/imageCropsDefaults';
import menuLink from "./menuLink";
const primaryColor = '#FF7320';
const searchPlaceholderImage = {
    src: '/bkw/images/vbp/logo.svg',
    alt: 'Logo Bibliotheek Twente',
    width: "165",
    height: "60"
};
export const defaults = {
    homeJumbo,
    genericLargeJumbo: largeJumbo,
    footerTop,
    newsletterBlock,
    notFoundPath: '/404',
    imageCrops: customImageCrops,
    searchPlaceholderImage,
    primaryColor,
    menuLink,
    onNavigationItemClick: ()=>{},
    copy: {
        forms: {
            loadingFailed: 'Het formulier kon helaas niet geladen worden. Herlaad de pagina of neem contact op met Bibliotheek Kennemerwaard.'
        },
        vacancies: {
            noVacanciesFound: `Op dit moment zijn er helaas geen vacatures beschikbaar. Maar dat wil niet zeggen dat jij
        niets voor de bibliotheek kunt betekenen. Stuur ons dus vooral jouw contactgegevens en cv.
        Wellicht hebben we binnenkort wél een geschikte vacature!`
        }
    },
    features: {
        autoHyphenate: true,
        manualHyphenate: true
    }
};
